export default (opt = {}) => {
    let editor = opt.editor,
        styleManager = editor.StyleManager;

    /**
     * Allow to select a component from a range of predefined styles of components
     *
     * @param {object} props
     * @param {int} props.default
     * @param {string} props.property
     * @param {grapesjs.Component} props.component
     * @param {function} [props.callback] optional callback to trigger on button change
     * @param {PresetComponentVO[]} props.list
     * @param {string} props.type
     */
    styleManager.addType(window.PMW.emails.styles.ID_PRESET_SELECTOR, {
        create({props, change}) {
            props.component = props.component || editor.getSelected();
            const currComponent = props.component,
                componentSelector = document.createElement('div'),
                selectedPresetID = currComponent.get(props.property) || props.default;

            componentSelector.className = props.type;
            componentSelector.innerHTML = getCompPresetsHTML(props, selectedPresetID);

            attachComponentPresetHandler(props, change, componentSelector);
            return componentSelector;
        },

        emit({props}, {presetEl, presetID}) {
            $(presetEl).addClass('-selected').siblings('.preset-wrapper').removeClass('-selected');
            props.component.set(props.property, presetID);

            if (typeof props.callback === 'function') {
                const presetIndex = props.list.findIndex(presetCompVO => {
                    return presetCompVO.id === presetID;
                });
                props.callback(props.component, props.list[presetIndex]);
            }
        }
    });

    /**
     * @param {object} props
     * @param {function} change
     * @param {HTMLElement} componentSelector
     */
    function attachComponentPresetHandler(props, change, componentSelector) {
        componentSelector.querySelectorAll('.js-comp-preset').forEach(presetEl => {
            const presetID = parseInt(presetEl.getAttribute('data-preset-id'));

            presetEl.addEventListener('click', function (componentSelector, presetEl, presetID) {
                change({componentSelector, presetEl, presetID});
            }.bind(null, componentSelector, presetEl, presetID));
        });
    }

    /**
     * @param {object} props
     * @param { PresetComponentVO[]} props.list
     * @param {number} selectedPresetID
     * @return {string}  containing markup for  column presets
     */
    function getCompPresetsHTML(props, selectedPresetID) {
        return `<div class="comp-presets">` +
            props.list.map((preset) => {
                return preset.render(selectedPresetID);
            }).join('') +
            `</div>`;
    }
};